import React from "react";
import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData"; // Adjust the path if DefaultData.js is located elsewhere

const ClientTabs = (props) => {
  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };
  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };
  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };
  const getStyle = (pageName) =>
    props.pageName === pageName ? activeTabStyle : inactiveTabStyle;

  return (
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
        <li className="nav-item">
          <Link
            to={"/company/clients"}
            className="nav-link"
            style={getStyle("CLIENTS")}
          >
            CLIENTS
          </Link>
        </li>
       
  
        <li className="nav-item">
          <Link
            to={"/clientwallet"}
            className="nav-link"
            style={getStyle("CLIENTWALLET")}
          >
            CLIENT WALLET
          </Link>
        </li>

          <li className="nav-item">
          <Link
              to={"/client/paymentgatewaylist"}
            className="nav-link"
            style={getStyle("CLIENTPAYMENTGATEWAY")}
          >
            CLIENT PAYMENTGATEWAY LIST
          </Link>
        </li>

  <li className="nav-item">
          <Link
            to={"/assign-template-to-agent"}
            className="nav-link"
            style={getStyle("ASSIGNTEMPLATE")}
          >
            Assign Template to Agent
          </Link>
        </li>
       <li className="nav-item">
          <Link
            to={"/b2c-companies"}
            className="nav-link"
            style={getStyle("B2C")}
          >
            B2C Client
          </Link>
        </li>
 <li className="nav-item">
          <Link
            to={"/b2b-companies"}
            className="nav-link"
            style={getStyle("B2B")}
          >
            B2B Client
          </Link>
        </li>

         <li className="nav-item">
          <Link
            to={"/b2e-companies"}
            className="nav-link"
            style={getStyle("B2E")}
          >
            B2E Client
          </Link>
        </li>
        
      </ul>
    </div>
  );
};

export default ClientTabs;
